import React from 'react'
import { Route } from 'react-router-dom'
import { withAuthenticationRequired } from '@auth0/auth0-react'
import { Loading } from '../components/index'

// tried 'ReactNode', error thrown: 'ReactNode' is not assignable to parameter of type 'ComponentType<any>'
type ProtectedRouteType = {
  component: any
  exact: boolean
  path: string
}

const ProtectedRoute = ({ component, ...args }: ProtectedRouteType) => {
  return (
    <Route
      component={withAuthenticationRequired(component, {
        onRedirecting: () => <Loading />
      })}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...args}
    />
  )
}

export default ProtectedRoute
